import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from '@mui/material';
const MetricChip = ({ value, total }) => {
    const format = new Intl.NumberFormat().format;
    const label = total != null ? `${format(value)}/${format(total)}` : format(value);
    return (_jsx(Chip, { label: label, size: 'medium', sx: {
            height: 32,
            minWidth: 32,
            maxWidth: '100%',
            borderRadius: '10px',
            px: 1,
            bgcolor: (themeObj) => themeObj.palette.action.selected,
            color: (themeObj) => themeObj.palette.text.primary,
            '& .MuiChip-label': {
                px: 0,
                fontWeight: 500,
                whiteSpace: 'nowrap'
            }
        } }));
};
export default MetricChip;
